module.exports = __webpack_public_path__ + "static/img/missing.222d8f11.png";